export default defineNuxtPlugin(() => {
    return {
        provide: {
            messages: {
                afterPasswordResetLoginMessage: `パスワードを再設定しました。
                ログインしてください。`,
                afterEmailResetLoginMessage :`メールアドレスを変更しました。
                ログインしてください。`,
                registeredLoginMessage : `すでにご登録いただいているメールアドレスです。
                ログインしてください。`,
                hasOtherTenantRegisteredLoginMessage: `すでにご登録いただいているサービスがございます。`,

                loginFailedMessage: `ログインに失敗しました。
                                                                        パスワードとメールアドレスを確認してください。`,
                tooManyAttemptsMessage: `ログイン試行回数が上限に達しました。1時間後に再試行してください。`,
                passwordNotSame :`確認用のパスワードが一致しません。正しく入力してください。`,
                unhandledError: '不明なエラーが発生しました'
            }
        }
    }
})
